import Vue from 'vue';
import FormatterHelper from '@/scripts/helpers/formatter.helper.js'

Vue.filter('FormatDate', (date) => {
    return FormatterHelper.formatDate(date);
});